import { AUTHORIZATION_TYPES } from './service/authApi';
import * as types from './types';

const initialState = {
  logoutWarning: false,
  isAuthenticated: false,
  isFetching: false,
  authError: undefined,
  // FIX: add stricter authorization by default but need jwt to support sesison type
  // authorizationType: AUTHORIZATION_TYPES.EVERYONE,
  authorizationType: AUTHORIZATION_TYPES.PHYSICIAN,
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [types.SEND_LOGOUT_WARNING]: (state, action) => ({
    ...state,
    logoutWarning: action.payload,
  }),
  [types.AUTHENTICATION_REQUEST]: state => ({
    ...state,
    isFetching: true,
  }),
  [types.AUTHENTICATION_SUCCESS]: state => ({
    ...state,
    isAuthenticated: true,
    isFetching: false,
    authError: '',
  }),
  [types.AUTHENTICATION_FAILURE]: (state, action) => ({
    ...state,
    isFetching: false,
    authError: action.payload,
  }),
  [types.CLEAR_AUTHENTICATION]: state => ({
    ...state,
    isAuthenticated: false,
  }),
  [types.SET_AUTHENTICATION]: state => ({
    ...state,
    isAuthenticated: true,
  }),
  [types.CHANGE_AUTHORIZATION_TYPE]: (state, action) => ({
    ...state,
    authorizationType: action.payload,
  }),
  [types.CLEAR_STATE]: () => ({ ...initialState }),
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function authReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/auth/state/authReducers.js